import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

const painPoints = [
  "I post every day and still make $0 from my content.",
  "I'm waiting to hit 10,000 followers before I try to monetise. But that day never comes.",
  "I know my audience trusts me — I just don't know what to sell them.",
  "I tried to build a digital product once. It took 3 months and I never finished it.",
  "I'm watching other creators make $10K/month with half my followers and I can't figure out what I'm missing.",
];

export const CreatorsNeedYouSection = () => {
  return (
    <section className="py-10 md:py-20 relative" style={{ background: "#FFFFFF" }}>
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <ScrollReveal>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 max-w-6xl mx-auto">
            <div>
              <h2 className="font-display font-bold mb-6 md:mb-8" style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 40px)", lineHeight: 1.2 }}>
                Sound familiar?
              </h2>
              <div className="space-y-3 md:space-y-4">
                {painPoints.map((point, i) => (
                  <ScrollReveal key={i} delay={i * 100}>
                    <div className="p-4 md:p-5 rounded-2xl bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" style={{ border: "1px solid #E5E7EB" }}>
                      <p className="text-sm md:text-base leading-relaxed" style={{ color: "#4B5563" }}>{point}</p>
                    </div>
                  </ScrollReveal>
                ))}
              </div>
            </div>

            <div className="flex flex-col justify-center">
              <div className="p-6 md:p-8 rounded-2xl bg-white" style={{ border: "1px solid #E5E7EB" }}>
                <p className="text-base md:text-lg leading-relaxed font-medium" style={{ color: "#111827" }}>
                  You don't have a content problem. You don't have an audience problem. You don't even have a size problem.
                </p>
                <p className="text-base md:text-lg leading-relaxed font-medium mt-4" style={{ color: "#111827" }}>
                  You have a <span className="font-bold" style={{ color: "#F59E0B" }}>monetisation system</span> problem.
                </p>
                <p className="text-base md:text-lg leading-relaxed font-medium mt-4" style={{ color: "#111827" }}>
                  AI Storycraft Studio is the system. And it works whether you have{" "}
                  <span className="font-bold" style={{ color: "#F59E0B" }}>500 followers or 500,000</span>.
                </p>
              </div>

              <div className="mt-6 md:mt-8">
                <a href="#pricing" className="inline-block w-full md:w-auto">
                  <Button variant="hero" size="lg" className="group w-full md:w-auto max-w-[400px] btn-interactive">
                    Start Your Free Trial
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
